module.exports = __webpack_public_path__ + "img/80.08b2dec0.jpg";